import 'plyr';

const DEFAULT_QUALITY = 720;

export class PrkPlayer {
    player = null;

    /**
     * 
     * @param {NodeList | HTMLElement | HTMLElement[] | string} targets
     * @param {Plyr.Options} options
     */
    constructor(targets, options) {
        // Init defaults
        options = options ?? {};
        options.controls = options.controls ?? ['play', 'progress', 'current-time', 'mute', 'volume', 'settings', 'fullscreen'];
        options.settings = options.settings ?? ['captions', 'quality'];
        options.quality = options.quality ?? {};
        options.quality.default = options.quality.default ?? DEFAULT_QUALITY;
        options.iconUrl = '/images/icons/svg/sprites/plyr-controls.svg';
        
        this.player = new Plyr(targets, options);
    }
}

export default PrkPlayer;